import { createTheme } from '@mui/material/styles';
import { fontStyles } from '../fontOverrides';
const theme = createTheme({
    palette: {
        primary: {
            main: '#2e5488',
        },
        secondary: {
            main: '#d68e65',
        },
        success: {
            main: '#5eb234',
        },
        warning: {
            main: '#ebb623',
        },
        error: {
            main: '#c91d1d',
        },
        info: {
            main: '#2e5488',
        },
        bankHoliday: {
            main: '#94a7c2',
        },
        offline: {
            main: '#c8cdd0',
            light: '',
            dark: '',
            contrastText: '',
        },
        approvedTaken: {
            main: '#b0dd99',
        },
        approvedFuture: {
            main: '#5eb234',
        },
        approved: {
            main: '#5eb234',
        },
        pending: {
            main: '#ebb623',
        },
        rejected: {
            main: '#e43535',
        },
        cancelled: {
            main: '#e48435',
        },
        pendingCancellation: {
            main: '#ebb623',
        },
        withdrawn: {
            main: '#959595',
        },
        entitlement: {
            main: '#30548c',
        },
        remaining: {
            main: '#30548c',
            contrastText: '#fff',
        },
        action: {
            disabledBackground: '#2e5488',
            disabled: '#fff',
        },
        textColor: {
            main: '#1F292E',
            light: '',
            dark: '',
            contrastText: '',
        },
        textSecondaryColor: {
            main: '#415058',
            light: '',
            dark: '',
            contrastText: '',
        },
        teamCalendarGrayColor: {
            main: '',
            light: '#F2F2F3',
            dark: '#C8CDD0',
            contrastText: '',
        },
    },
    typography: {
        h1: {
            fontFamily: 'Nunito bold',
        },
        button: {
            textTransform: 'none',
        },
        fontFamily: 'Nunito',
        fontSize: 16,
        body2: {
            fontSize: 15,
        },
        subtitle1: {
            fontSize: 14,
        },
        subtitle2: {
            fontSize: 12,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: fontStyles,
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '20px 34px',
                },
            },
        },
        MuiChip: {
            defaultProps: {
                sx: {
                    borderRadius: '0.5em',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 0.3,
                        pointerEvents: 'auto',
                    },
                },
            },
        },
        MuiMobileStepper: {
            styleOverrides: {
                root: {
                    '.MuiMobileStepper-dot:not(.MuiMobileStepper-dotActive)': {
                        backgroundColor: '#C8CDD0',
                    },
                },
            },
        },
    },
});
export { theme };
